import Bugsnag from '@bugsnag/js';

import { errorHandlerActionTypes } from '@/components/errorHandler/Constants';

import type {
	ErrorHandlerActions,
	ErrorHandlerState,
	ErrorResponse,
} from '@/components/errorHandler/types';

const initialState: ErrorHandlerState = {
	error: null,
	statusCode: '',
	ignoreError: false,
	displayNotification: false,
	hasError: false,
	typeError: 'page-blocking',
	customNotification: null,
};

export default function errorHandlerReducer(
	state = initialState,
	action: ErrorHandlerActions,
): ErrorHandlerState {
	const { type } = action;
	const { error, typeError, customNotification } =
		'payload' in action && action.payload
			? action.payload
			: { error: undefined, typeError: undefined, customNotification: undefined };
	const errorResponse = error as ErrorResponse | undefined;
	const { data, status } = (errorResponse && errorResponse.response) || {};

	switch (type) {
		case errorHandlerActionTypes.HANDLE_ERROR:
			let params: Partial<ErrorHandlerState> = {};

			if (state.hasError && (typeError === 'notification' || typeError === 'ignore')) {
				params = {
					...state,
				};
			} else {
				params = {
					ignoreError: typeError === 'ignore',
					displayNotification: typeError === 'notification',
				};
			}

			if (errorResponse) {
				Bugsnag.notify(errorResponse as Error, (event) => {
					const axiosMeta =
						(errorResponse.bugsnagMeta && errorResponse.bugsnagMeta.axios) ||
						errorResponse.axiosMeta;
					if (axiosMeta) {
						event.addMetadata('axios', axiosMeta);
					}
				});
			}

			return {
				hasError: true,
				error: data,
				statusCode: status || '',
				typeError: typeError || 'page-blocking',
				customNotification: customNotification || null,
				ignoreError: params.ignoreError ?? false,
				displayNotification: params.displayNotification ?? false,
			};

		case errorHandlerActionTypes.CLEAR_ERROR:
			return initialState;

		default:
			return state;
	}
}
